import { render, staticRenderFns } from "./FieldWorkplace2List.vue?vue&type=template&id=52856ef6&scoped=true&"
import script from "./FieldWorkplace2List.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplace2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52856ef6",
  null
  
)

export default component.exports